import { __awaiter, __decorate } from "tslib";
import { observable } from '@microsoft/fast-element';
/**
 * @internal
 */
export class AuthMock {
    constructor() {
        this.isWorking = false;
        this.loggedUserResult = null;
        this.currentUser = null;
        this.isLoggedIn = false;
    }
    login(credentials) {
        return __awaiter(this, void 0, void 0, function* () {
            return Promise.resolve(this.nextLoginResult);
        });
    }
    logout() {
        return __awaiter(this, void 0, void 0, function* () {
            return Promise.resolve(this.nextLogoutResult);
        });
    }
    reAuthFromSession() {
        return __awaiter(this, void 0, void 0, function* () {
            return Promise.resolve(this.nextReAuthResult);
        });
    }
}
__decorate([
    observable
], AuthMock.prototype, "isWorking", void 0);
__decorate([
    observable
], AuthMock.prototype, "loggedUserResult", void 0);
__decorate([
    observable
], AuthMock.prototype, "currentUser", void 0);
__decorate([
    observable
], AuthMock.prototype, "isLoggedIn", void 0);
